import(/* webpackMode: "eager" */ "/app/next/src/app/global-error.tsx");
